const locale = {
	notice_board: 'Notice Board Page',
	staff_schedule_title: 'Create Event Staff Schedule',
	edit_staff_schedule : 'Edit Staff Schedule',
	staff_schedule: 'Staff Schedule',
	today: 'Today',
	back_to_notices_list: 'Back to notices list',
	create_staff:'Create',
	mix_calendar:'Mix Calendar',
	view_notice_event:'View Notice',
	create_notice:"Create Notice",
	create:'Create',
	update_notice:"Update Notice",
	select_project:'Select Project',
	permission:'Permission',
	expired_date:'Expired Date',
	edit:'Edit',
	posted:'Posted',
	user:'User',
	content:'Content',
	read_by:'Read By',
	flag_as_important:'Flag as important',
	cancel:'Cancel',
	delete:'Delete',
	submit:'Submit',
	update:'Update',
	enter_valid_date:'Enter a valid date',
	date_should_not_be_before_todays_date: 'Date should not be before todays date',
	drag_n_drop_some_files_here_or_click_to_select_files:'Drag and drop some files here, or click to select files',
	please_enter_a_valid_url: 'Please enter a valid URL',

	details:'Details',
	name: 'Name',
	aqua:'Aqua',
	lemon: 'Lemon',
	olive: 'Olive',
	crimson: 'Crimson',
	lilac: 'Lilac',
	gray: 'Gray',
	crepe: 'Crepe',
	sage: 'Sage',
	blush: 'Blush',
	royal_blue: 'Royal Blue',
	title: 'Title',
	all_day:'All Day',
	go_direct: 'Go Direct',
	return_direct: 'Return Direct',
	to: 'to',
	repeat:'Repeat',
	until:'Until',
	interval:'Interval',
	select:'Select',
	daily: 'Daily',
	weekly: 'Weekly',
	monthly: 'Monthly',
	yearly: 'Yearly',
	custom: 'Custom',
	week: 'Week',
	month: 'Month',
	year: 'Year',
	mon:'Mon',
	tue: 'Tue',
	wed:'Wed',
	thu:'Thu',
	fri:'Fri',
	sat:'Sat',
	sun:'Sun',
	monday:'Monday',
	tuesday: 'Tuesday',
	wednesday:'Wednesday',
	thursday:'Thursday',
	friday:'Friday',
	saturday:'Saturday',
	sunday:'Sunday',
	last: 'Last',
	start_time: 'Start Time',
	end_time: 'End Time',
	please_select_an_option:'Please, select an option',
	show_more: 'Show more',
	delete_this_staff_event: 'Delete this Staff Event',

	view_staff_schedule_title: 'View Staff Schedule',
	created_by: 'Created by',
	start_date: 'Start Date',
	dashboard: 'Dashboard',
	repeat_every: 'every',

	max: 'Max',
	min: 'Min',
	feels_like: 'Feels like',
};

export default locale;
